import React, { ReactElement } from 'react'
import { Svg } from 'ui'
import LightBulbIcon from 'images/dashboard/bright-light-bulb.svg'
import { Flex, Text } from 'theme-ui'
import { Link } from '@reach/router'
import useQueryString from 'utils/useQueryString'

export default function CreateProvisioningCodeMessage(): ReactElement {
  const { qs } = useQueryString()

  return (
    <Flex
      sx={{
        width: '100%',
        flexDirection: 'row',
        px: '1.6rem',
        py: '1.2rem',
        gap: '0.8rem',
        backgroundColor: 'cyan20',
      }}
    >
      <Svg
        svg={LightBulbIcon}
        fill="aliceBlue60"
        sx={{
          width: '1.6rem',
          height: '1.6rem',
          flexShrink: 0,
        }}
        descriptiveText="Information about RMM endpoints"
      />
      <Text variant="size12Weight400" sx={{ color: 'aliceBlue60' }}>
        Need multiple Endpoints using RMM?{' '}
        <Link
          to={`/dashboard/provision?provisionDialog=add${qs.orgId ? `&orgId=${qs.orgId}` : ''}`}
          style={{
            color: 'inherit',
          }}
          data-testid="provision-button"
          aria-label="create provisioning code"
        >
          Create Provisioning Code
        </Link>
      </Text>
    </Flex>
  )
}
